// extracted by mini-css-extract-plugin
export default {"pdfPaginator":"styles_pdfPaginator__mby7w","littlePDF":"styles_littlePDF__gFtXh"};